import { render } from "./LicenseInfo.vue?vue&type=template&id=50218f64"
import script from "./LicenseInfo.vue?vue&type=script&lang=js"
export * from "./LicenseInfo.vue?vue&type=script&lang=js"

import "./LicenseInfo.vue?vue&type=style&index=0&id=50218f64&lang=css"

import exportComponent from "/root/esg_nexus/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__